module.exports = __webpack_public_path__ + "img/vk-dark.c3c0b267.svg";